import React from 'react'
import classNames from 'classnames'
import { WemoloAccordion, WemoloButton, WemoloToggle } from '../../../../components/Wemolo'
import styles from './ViewBox.module.css'

interface ViewBox {
    title: string
    toggleLable?: string
    checked?: boolean
    setChecked?: (checked: boolean) => void
    children?: React.ReactNode
    onDefault?: () => void
    confirmText?: string
}

export const ViewBox: React.FC<ViewBox> = ({
    title,
    toggleLable,
    checked,
    setChecked,
    children,
    onDefault,
    confirmText
}) => {
    const hasToggle = Boolean(toggleLable && setChecked)

    return (
        <div className={styles.root}>
            <WemoloAccordion title={title} defaultExpanded={true}>
                <div className={styles.body}>
                    <div className={classNames(styles.header, hasToggle && styles.headerWithToggle)}>
                        {hasToggle && (
                            <WemoloToggle
                                size="small"
                                checked={checked || false}
                                label={toggleLable}
                                onChange={(e) => {
                                    const newChecked = e.target.checked
                                    if (!newChecked || !confirmText || window.confirm(confirmText)) {
                                        setChecked!(newChecked)
                                    }
                                }}
                            />
                        )}
                        <WemoloButton
                            view="ghost"
                            size="small"
                            icon={
                                <i className="material-icons" aria-hidden="true">
                                    refresh
                                </i>
                            }
                            onClick={() => {
                                if (window.confirm(`Are you sure you want to reset ${title} to default values?`)) {
                                    onDefault && onDefault()
                                }
                            }}
                        >
                            Default
                        </WemoloButton>
                    </div>
                    {children}
                </div>
            </WemoloAccordion>
        </div>
    )
}
